import React, { useState } from 'react';
import { User } from '../types';
import '../styles/Header.css';

interface Props {
  user: User;
  onLogout: () => void;
  onNavigate: (page: 'list' | 'create') => void;
  currentPage: string;
  loginDisabled?: boolean;
  onToggleLogin?: (disable: boolean) => void;
}

const Header: React.FC<Props> = ({
  user,
  onLogout,
  onNavigate,
  currentPage,
  loginDisabled = false,
  onToggleLogin,
}) => {
  const initial = (user.username || '?').charAt(0).toUpperCase();
  const [settingsOpen, setSettingsOpen] = useState(false);

  return (
    <header className="app-header">
      <div className="header-left">
        <button className="logo" onClick={() => onNavigate('list')}>
          <span className="logo-mark">⚡</span>
          <span className="logo-text">
            EA <strong>Spec Driven</strong>
          </span>
        </button>
        <nav className="nav-links">
          <button
            className={currentPage === 'list' ? 'active' : ''}
            onClick={() => onNavigate('list')}
          >
            My Apps
          </button>
          <button
            className={currentPage === 'create' || currentPage === 'edit' ? 'active' : ''}
            onClick={() => onNavigate('create')}
          >
            Create New
          </button>
        </nav>
      </div>

      <div className="header-right">
        {user.isAdmin && onToggleLogin && (
          <div style={{ position: 'relative' }}>
            <button
              className="logout-btn"
              title="Settings"
              onClick={() => setSettingsOpen((v) => !v)}
              style={{ marginRight: 8 }}
            >
              ⚙ Settings
            </button>
            {settingsOpen && (
              <div
                style={{
                  position: 'absolute',
                  right: 0,
                  top: '110%',
                  zIndex: 50,
                  minWidth: 300,
                  background: '#fff',
                  color: '#1e293b',
                  border: '1px solid #e2e8f0',
                  borderRadius: 10,
                  boxShadow: '0 8px 28px rgba(0,0,0,0.18)',
                  padding: 16,
                }}
              >
                <div style={{ fontWeight: 600, marginBottom: 6 }}>Access control</div>
                <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={loginDisabled}
                    onChange={(e) => {
                      onToggleLogin(e.target.checked);
                      setSettingsOpen(false);
                    }}
                    style={{ marginTop: 3 }}
                  />
                  <span>
                    <span style={{ fontWeight: 600 }}>Disable Cognito login</span>
                    <br />
                    <span style={{ fontSize: 12, color: '#64748b' }}>
                      When ON, anyone who opens this site lands as{' '}
                      <b>m.imokawa</b> admin (no login). When OFF, Cognito login is
                      required.
                    </span>
                  </span>
                </label>
                <div
                  style={{
                    marginTop: 12,
                    fontSize: 12,
                    padding: '6px 10px',
                    borderRadius: 6,
                    background: loginDisabled ? '#fef3c7' : '#dcfce7',
                    color: loginDisabled ? '#92400e' : '#166534',
                  }}
                >
                  Current: login is <b>{loginDisabled ? 'DISABLED (guest admin)' : 'REQUIRED'}</b>
                </div>
              </div>
            )}
          </div>
        )}
        <div className="user-info" title={user.email || user.username}>
          <span className="user-avatar">{initial}</span>
          <span className="username">{user.username}</span>
          {user.isAdmin && <span className="admin-badge">Admin</span>}
          {user.guest && <span className="admin-badge" style={{ background: '#f59e0b' }}>Guest</span>}
        </div>
        <button className="logout-btn" onClick={onLogout}>
          {user.guest ? 'Exit' : 'Sign out'}
        </button>
      </div>
    </header>
  );
};

export default Header;
